import React, { useState } from "react";
import Select from "react-select";
import { AppBar, Button, Divider, Grid, Stack, TextField } from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import Calendar from "../../calendar/Calendar";
import { useNavigate } from "react-router-dom";

const employmentOption = [{ label: "Intership" }, { label: "Contract" }];
const departmentOption = [
  { label: "HR" },
  { label: "Deployment" },
  { label: "Testing" },
  { label: "BDE" },
];
const workTitleOption = [
  { label: "ALL" },
  { label: "Executive" },
  { label: "Manager" },
  { label: "Supervisor" },
];
const periodYearOption = [
  { label: "2020" },
  { label: "2021" },
  { label: "2022" },
  { label: "2023" },
];
const periodMonthOption = [
  { label: "Jun" },
  { label: "July" },
  { label: "August" },
  { label: "September" },
];
const subPeriodOption = [{ label: "Employee" }, { label: "Day" }];
const workModelOption = [{ label: "Regular" }, { label: "Freelancer" }];
const workTypeOption = [{ label: "Full Time" }, { label: "Part Time" }];

const initialValue = {
  company: "",
  department: "",
  workTitle: "ALL",
  employment: "",
  year: "",
  month: "",
  subPeriod: "",
  workModel: "",
  workType: "",
};

const AttendanceLogForm = ({ setPage }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [data, setData] = useState(initialValue);

  const handleAdd = () => {
    setShow(true);
    setPage(1);
  };

  const handleShowAttendance = () => {
    setPage(2);
  };
  const handleChange = (value, name) => {
    setData({ ...data, [name]: value.label });
  };
  return (
    <div>
      <Grid container spacing={2} className="p-16">
        <Grid item xs={8}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Stack>
                <label>Company</label>
                <TextField
                  className="mb-16"
                  type="text"
                  name="company"
                  // value={data.company}
                  // error={(checkSubmit && !data.company) || validError.company ? true : false}
                  // helperText={(checkSubmit && !data.company) ? "" : validError.company}
                  // onChange={(e) => { handleChange(e); setValidError({ ...validError, company: checkString(e.target.value) }) }}
                  variant="outlined"
                />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Stack>
                <label>Select Employment</label>
                <Select
                  className="mb-16"
                  name="employment"
                  value={
                    (data.employment && employmentOption) ||
                    employmentOption.filter(
                      (obj) => data.employment === obj.label
                    )
                  }
                  onChange={(e) => handleChange(e, "employment")}
                  options={employmentOption}
                  styles={customStyles()}
                />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Stack>
                <label>Select Department</label>
                <Select
                  className="mb-16"
                  name="department"
                  value={
                    data.department &&
                    departmentOption &&
                    departmentOption.filter(
                      (obj) => data.department === obj.label
                    )
                  }
                  onChange={(e) => handleChange(e, "department")}
                  options={departmentOption}
                  styles={customStyles()}
                />
              </Stack>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Stack>
                <label>Select Period Year</label>
                <Select
                  className="mb-16"
                  name="year"
                  value={
                    data.year &&
                    periodYearOption &&
                    periodYearOption.filter((obj) => data.year === obj.label)
                  }
                  onChange={(e) => handleChange(e, "year")}
                  options={periodYearOption}
                  styles={customStyles()}
                />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Stack>
                <label>Select Period Month</label>
                <Select
                  className="mb-16"
                  name="month"
                  value={
                    data.month &&
                    periodMonthOption &&
                    periodMonthOption.filter((obj) => data.month === obj.label)
                  }
                  onChange={(e) => handleChange(e, "month")}
                  options={periodMonthOption}
                  styles={customStyles()}
                />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Stack>
                <label>Select Sub Period</label>
                <Select
                  className="mb-16"
                  name="subPeriod"
                  value={
                    data.subPeriod &&
                    subPeriodOption &&
                    subPeriodOption.filter(
                      (obj) => data.subPeriod === obj.label
                    )
                  }
                  onChange={(e) => handleChange(e, "subPeriod")}
                  options={subPeriodOption}
                  styles={customStyles()}
                />
              </Stack>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Stack>
                <label>Select Work Title</label>
                <Select
                  className="mb-16"
                  name="workTitle"
                  value={
                    data.workTitle &&
                    workTitleOption &&
                    workTitleOption.filter(
                      (obj) => data.workTitle === obj.label
                    )
                  }
                  onChange={(e) => handleChange(e, "workTitle")}
                  options={workTitleOption}
                  styles={customStyles()}
                />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Stack>
                <label>Select Work Model</label>
                <Select
                  className="mb-16"
                  name="workModel"
                  value={
                    data.workModel &&
                    workModelOption &&
                    workModelOption.filter(
                      (obj) => data.workModel === obj.label
                    )
                  }
                  onChange={(e) => handleChange(e, "workModel")}
                  options={workModelOption}
                  styles={customStyles()}
                />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Stack>
                <label>Select Work Type</label>
                <Select
                  className="mb-16"
                  name="workType"
                  value={
                    data.workType &&
                    workTypeOption &&
                    workTypeOption.filter((obj) => data.workType === obj.label)
                  }
                  onChange={(e) => handleChange(e, "workType")}
                  options={workTypeOption}
                  styles={customStyles()}
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid className="ml-16 flex">
        <div>
          <Button
            variant="contained"
            color="warning"
            className="mb-16"
            onClick={handleShowAttendance}
          >
            {/* Submit */}
            <FuseSvgIcon>heroicons-outline:eye</FuseSvgIcon>
          </Button>
        </div>
        <div>
          <Button
            variant="contained"
            color="warning"
            className="mb-16 ml-16"
            onClick={handleAdd}
          >
            {/* Submit */}
            <FuseSvgIcon>heroicons-outline:plus-circle</FuseSvgIcon>
          </Button>
        </div>
        <div>
          <Button variant="contained" color="warning" className="mb-16 ml-16">
            {/* Submit */}
            <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
          </Button>
        </div>
        <div>
          <Button variant="contained" color="warning" className="mb-16 ml-16">
            {/* Submit */}
            <FuseSvgIcon>heroicons-outline:save</FuseSvgIcon>
          </Button>
        </div>
      </Grid>
      <Grid>
        <Calendar />
      </Grid>
    </div>
  );
};

export default AttendanceLogForm;
